import { features } from './features'; 

features.applicationType = 'gardengest';

/* features.fincaName = "Parque";
features.fincasName = "Parques";*/

features.fincaName = 'Dirección';
features.fincasName = 'Direcciones';
features.parcelaName = 'Zona';
features.parcelasName = 'Zonas';
features.sectorName = 'Jardin';
features.sectoresName = 'Jardines';
features.comerciosName = 'Empresa';
features.comercioName = 'Empresas';
features.nameModuloGanaderia = 'Jardineria';

features.showEstadisticas = false;
features.showAnalisis = false;
features.showCargaPAC = false;
features.showVisitas = false;
features.showVisitasCamposPersonalizados = false;
features.showVisitasConsultas = false;
features.showEnviarWhatsappVisitas = true;
features.showEnviarCorreoVisitas = true;
features.showVisitasUploadPhotos = false;
features.showVentas = true;
features.showVentasComercioProveedor = true;
features.showPartida = true;
features.puedeImprimir = true;
features.showAbonado = true;
features.showMapas = true;
features.hasClients = false;
features.hasAplicadores = true;
features.showVademecumListadoProductos = true;
features.showVademecumMenu = true;
features.showStock = true;
features.showPhCaldo = true;
features.showEnviarWhatsapp = true;
features.showEnviarCorreo = true;
features.showEnviarWhatsappVisitas = false;
features.showEnviarCorreoVisitas = false;
features.showTareasBio = false;
features.showTareasOtros = true;
features.showOrdenAplicacionProductos = true;
features.showMeteoBtn = true;
features.showRecetaGlobalGAP = false;
features.adminCanSeeAllRecords = true;
features.showVisitasUploadPhotos = false;
features.showMapasSatelite = false;
features.showAnalisisSectorParcelas = true;
features.showTareasSiembra = false;
features.showRopoRomaRegepa = true;
features.showConsultaRopo = false;
features.showMotivo = true;
features.showStock = true;
features.showStockTipoDeDato = true;
features.showStockProveedor = true;
features.showStockEnvase = false;
features.showStockLotePropio = false;
features.showReto = false;
features.showVentusky = true;
features.showFotoTrajador = true;
features.showProductosFeritilizantes = false;
features.showVademecumListadoProductos = false;
features.showSigPacParcela = false;
features.showCuadernoDeCampo = true;
features.puedeImprimir = true;
features.showTratamientosMenu = true;
features.textoSuperficie = 'm²';
features.showProductosFeritilizantes = true;
features.showTareasFertilizantes = true;
features.showClientesNotas = true;
features.showHistoricoFT = true;
features.showTareasMto = true;
features.showWidthFertilizanteNombre = true;
features.clientesMostrarTodosDefault = true;
features.showFincasInformeTratamientos = true;
features.timeStartStopTareas = true;

features.userCanSeeAllRecords = true;
features.timeStartStopTareas = true;
features.showTareasFitoBetweenDates = true;
features.userSoloCanSeeInfo = true;

features.showTareasAplicados = false;
features.showBtnTratamiento = true;
features.showCostes = true;

features.showEstadisticas = false;
features.showUsuariosLogs = true;
features.showClientesCrm = false;
features.showCrm = true;
features.showCalendarioTareas = true;
features.showTareasOtrasProducto = true;
features.showTareasOtrasCantidad = true;
features.showTareasOtrasUnidadMedida = false;
features.activateREA = false;
features.showTareasGenericasObservaciones = true;
features.hasCultivosPropios = true;
features.showMaquinariaAdjuntoPdf = true;
features.showStockProveedorClienteDropdown = true;
features.showStockCifProveedor = false;

features.showGanaderia = true;
features.showStockSemilla = true;

export const environment = {
    production: true,
    v: '6.1',
    serverUrl: 'https://detorres.gardengest.com/',
    logoUrl: 'assets/logo_detorres.png',
    horizontalLogoUrl:'',
    appName: 'detorres',
    features: features
};